import React from 'react'
import styles from './styles.module.css'

function CKDPatientTooltip() {
  return (
    <div className={styles.ckd_patient_tooltip_wrap}>
      <p>基于CGA分期判断CKD分期</p>
      {/* <p>CKD分期：CGA分期</p> */}
    </div>
  )
}

export default CKDPatientTooltip
